// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"170d35fa","202":"cbb0db52","217":"8dffb332","223":"3e97457e","354":"ced45bc7","422":"d4553934","633":"0c0d9a8a","983":"c0daa952"}[chunkId] + ".chunk.js";
};